export const ADMINDRAWER_OPEN = "ADMINDRAWER_OPEN"
export const ADMINDRAWER_CLOSE = "ADMINDRAWER_CLOSE"
export const APP_DRAWER_TOGGLE = "APP_DRAWER_TOGGLE"



// WEBPACK FOOTER //
// ./src/types/actions/drawers.js